import accounting from 'accounting'

// TODO: This should be expanded in order to support more currencies and edge cases
// - Custom thousand separators
// - Custom decimal point separators
/**
 * Keep this in sync with https://github.com/taskworld/tw-marketing/blob/master/src/utils/formatMoney.js
 */
export default function formatMoney({
  amount: formalAmount,
  currency,
  precisionNotPreferred,
}: {
  currency: string
  amount: number | [number, number]
  precisionNotPreferred?: boolean
}) {
  const { precision, format } = Currencies[currency.toLowerCase()] || {
    precision: 0,
    format: (value) => [
      {
        type: 'amount',
        text: value,
      },
      {
        type: 'code',
        text: ' ' + currency.toUpperCase(),
      },
    ],
  }

  const stringAmount = (() => {
    const rangedAmount = typeof formalAmount === 'number' ? [formalAmount] : formalAmount

    const actualAmount =
      precision > 0 ? rangedAmount.map((amount) => amount / Math.pow(10, precision)) : rangedAmount

    return actualAmount
      .map((amount) =>
        accounting.formatMoney(amount, {
          format: '%v', // Do not remove this as it will fall back to '$%v'
          precision: precisionNotPreferred && Math.floor(amount) === amount ? 0 : precision,
        }),
      )
      .join('-')
  })()

  const fragments = format(stringAmount)
  fragments.toString = () => fragments.map(({ text }) => text).join('')
  return fragments
}

const Currencies: {
  [currency: string]:
    | {
        precision: number
        format: (value: string) => Array<{ type: 'symbol' | 'amount' | 'code'; text: string }>
      }
    | undefined
} = {
  brl: {
    precision: 2,
    format: (value) => [
      {
        type: 'symbol',
        text: 'R$',
      },
      {
        type: 'amount',
        text: value,
      },
    ],
  },
  eur: {
    precision: 2,
    format: (value) => [
      {
        type: 'symbol',
        text: '€',
      },
      {
        type: 'amount',
        text: value,
      },
    ],
  },
  jpy: {
    precision: 0,
    format: (value) => [
      {
        type: 'symbol',
        text: '¥',
      },
      {
        type: 'amount',
        text: value,
      },
    ],
  },
  thb: {
    precision: 2,
    format: (value) => [
      {
        type: 'symbol',
        text: '฿',
      },
      {
        type: 'amount',
        text: value,
      },
    ],
  },
  gbp: {
    precision: 2,
    format: (value) => [
      {
        type: 'symbol',
        text: '£',
      },
      {
        type: 'amount',
        text: value,
      },
    ],
  },
  usd: {
    precision: 2,
    format: (value) => [
      {
        type: 'symbol',
        text: 'US$', // The presence of US here is to avoid confusions with AUD, SGD, and so on
      },
      {
        type: 'amount',
        text: value,
      },
    ],
  },
}
